var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { IconButton, Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { GridMoreVertIcon } from "@mui/x-data-grid";
import React from "react";
import { useRecordContext } from "react-admin";
import { useTranslation } from "react-i18next";
var PREFIX = "ListActionsMenu";
var classes = {
    menu: "".concat(PREFIX, "-menu"),
};
var Root = styled("div")((_a = {},
    _a["& .".concat(classes.menu)] = {
        width: "max-content",
    },
    _a));
export var ListActionsMenu = function (props) {
    var t = useTranslation().t;
    var record = useRecordContext();
    var actions = props.actions;
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var filteredActions = actions.filter(function (action) { return !action.showAction || ((record === null || record === void 0 ? void 0 : record.id) && action.showAction(record === null || record === void 0 ? void 0 : record.id)); });
    var handleClickAction = function (action) {
        if (!(record === null || record === void 0 ? void 0 : record.id)) {
            return;
        }
        action.action(record.id);
        if (action.saveRecordAction) {
            action.saveRecordAction(record);
        }
        handleClose();
    };
    return (_jsxs(Root, { children: [_jsx(IconButton, { id: "actions-menu-button", "aria-label": t("common.label.actions"), "aria-controls": open ? "actions-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick, children: _jsx(GridMoreVertIcon, {}) }), _jsx(Menu, { classes: { paper: classes.menu }, id: "actions-menu", "aria-labelledby": "actions-menu-button", anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, children: filteredActions && filteredActions.length > 0
                    ? filteredActions.map(function (action, index) {
                        var _a;
                        return (_jsxs(MenuItem, { onClick: function () { return handleClickAction(action); }, sx: { display: "flex", gap: "8px" }, className: (_a = action.className) !== null && _a !== void 0 ? _a : "", children: [action.icon, action.label || ""] }, index));
                    })
                    : null })] }));
};
